class ForumEntriesOverview
    constructor: (el) ->
        @.$el = el
        @.$searchBarEl = @.$el.querySelector '.forum-entries-overview__searchbar'
        @.$sortSelect = @.$el.querySelector '.forum-entries-overview__sort'
        @.$sortSelectInput = @.$sortSelect?.querySelector('select') ? false
        @.$titleEl = @.$el.querySelector '.forum-entries-overview__head__title'
        @.$topicButton = @.$el.querySelector '.forum-entries-overview__topic-button'
        @.$topicsEl = @.$el.querySelector '.forum-entries-overview__topics'

        @.amount = @.$el.dataset?.amount ? 3
        @.api = @.$el.dataset?.api ? false
        @.apiMethod = @.$el.dataset?.apiMethod ? 'GET'
        @.forumId = @.$el.dataset?.forumId ? false
        @.loaded = @.$topicsEl.querySelectorAll('.forum-entry').length
        @.results = []
        @.topicOverlayId = @.$el.dataset?.topicOverlayId ? false
        @.total = if @.$el.dataset?.total then parseInt(@.$el.dataset.total,10) else false
        @.type = @.$el.dataset?.type ? 'forum'
        @.updateBreadcrumbs = @.$el.dataset?.ubc == "true"

        @.$el.classList.add 'forum-entries-overview--bound'

        
        @.InitEvents()
        if (!@.total || @.total < 1) && @.loaded == 0
            @.$el.classList.add 'forum-entries-overview--no-results'
        if @.updateBreadcrumbs
            @.UpdateBreadcrumbs()
        return

    AppendResults: ->
        self = @
        @.results.forEach (result) ->
            result.type = self.type
            self.$topicsEl.appendChild window.CreateForumEntry result
            return
        @.loaded += @.results.length
        window.dispatchEvent new CustomEvent 'bind-components', { bubbles: false }
        return

    GetData: ->
        if @.api
            if @.apiMethod == 'GET' || @.apiMethod == 'POST'
                self = @
                try
                    if @.apiMethod == 'POST'
                        body = {
                            amount: @.amount
                            offset: @.loaded
                        }
                    request = window.appUtils.XMLHttpRequest @.apiMethod, @.api
                        , ->
                            if request.responseText && request.responseText != ""
                                try
                                    answer = JSON.parse request.responseText
                                    self.results = answer.results
                                catch error
                                    console.log "Fehler beim Versuch die Datenquelle der Forums-Übersicht zu verarbeiten"
                                    self.AppendResults()
                                    return
                            else
                                console.log "Die Anfrage der Datenquelle der Forums-Übersicht lieferte ein leeres Ergebnis"
                            self.AppendResults()
                        , ->
                            self.AppendResults()
                            console.log "Bei der Anfrage an die Datenquelle der Forums-Übersicht ist leider ein Fehler aufgetreten"
                            return
                        , if self.apiMethod == 'POST' then JSON.stringify(body) else {}
                catch error
                    console.log "Fehler beim Versuch die Datenquelle der Forums-Übersicht zu ermitteln"
        return

    InitEvents: ->
        self = @

        if @.$topicButton && @.topicOverlayId
            @.$topicButton.addEventListener 'click', (e) ->
                topicOverlayEl = document.getElementById self.topicOverlayId
                if topicOverlayEl
                    topicOverlayEl.dispatchEvent new CustomEvent 'overlay-show', { bubbles: false }
                    openTopicOverlayEl = document.getElementById "overlay-id_#{ self.topicOverlayId }"
                    if openTopicOverlayEl
                        addEntryTopicEl = openTopicOverlayEl.querySelector '.add-entry--topic'
                        if addEntryTopicEl && typeof self.forumId != 'undefined'
                            addEntryTopicEl.dispatchEvent new CustomEvent 'add-entry-set-forum-id', {
                                bubbles: false
                                detail: {
                                    forumId: self.forumId
                                }
                            }
                return
        else
            if @.$topicButton
                @.$topicButton.remove()
        if @.$sortSelectInput
            @.$sortSelectInput.addEventListener 'change', (e) ->
                window.location = window.location.href.split("?")[0] + "?sort=" + @.value
        return
    
    UpdateBreadcrumbs: ->
        if @.updateBreadcrumbs && @.$titleEl
            self = @
            document.querySelectorAll '.breadcrumbs--bound'
                .forEach (bcEl) ->
                    bcEl.dispatchEvent new CustomEvent 'breadcrumbs-add', {
                        bubbles: false,
                        detail: {
                            items: [
                                {
                                    link: window.location.href
                                    text: self.$titleEl.textContent
                                }
                            ]
                        }
                    }
                    return
        return

BindForumEntriesOverviews = ->
    document.querySelectorAll '.forum-entries-overview:not(.forum-entries-overview--bound)'
        .forEach (el) ->
            new ForumEntriesOverview el
            return
    return

window.addEventListener 'bind-components', BindForumEntriesOverviews